import React, { useState, useEffect } from "react";
import { Space, Table, Tag, notification } from "antd";
import { Button } from "@mui/material";
import axios from "axios";
import { URL_API_LINK_INFRA_INVITE, URL_API_LINK_INFRA_SDK_TOKEN } from "../../api/endpoints";

const DASHBOARD_URL = "https://view-account.getphyllo.com/";

const columns = [
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
  },
  {
    title: "Action",
    dataIndex: "action",
    key: "action",
  },
  {
    title: "View",
    dataIndex: "view",
    key: "view",
  },
];

const InvitedUsers = () => {
  const [invitedUserData, setInvitedUsers] = useState();

  const onClickRemindHandler = async (email) => {
    await axios.post(`${URL_API_LINK_INFRA_INVITE}`, [{ email }]);
    notification.success({ message: "Invitation sent successfully!" });
  };

  const redirectToDashboard = async (userId, id) => {
    const response = await axios.get(`${URL_API_LINK_INFRA_SDK_TOKEN}?code=${id}`);
    const { user_id, sdk_token } = response.data;

    window.location.href = `${DASHBOARD_URL}dashboard?userId=${userId}&sdkToken=${sdk_token}`;
    // setTimeout(() => {

    // }, 2000);
  };

  const constructTableData = (data) => {
    const filteredData = [];
    data.map((item) => {
      filteredData.push({
        email: item.email,
        status: item.status,
        key: item.email,
        action: (
          <Space size="middle">
            <Button onClick={() => onClickRemindHandler(item.email)}>Remind</Button>
          </Space>
        ),
        view: (
          <Space size="middle">
            <Button onClick={() => redirectToDashboard(item.user_id, item.id)}>View</Button>
          </Space>
        ),
      });
    });
    setInvitedUsers(filteredData);
  };

  const fetchInvitedUsers = async () => {
    const { data } = await axios.get(`${URL_API_LINK_INFRA_INVITE}`);
    // const data = [
    //   {
    //     email: "sumukha@email.com",
    //     status: "INVITED",
    //   },
    //   {
    //     email: "sumukha@email.com",
    //     status: "INVITED",
    //   },
    // ];
    constructTableData(data);
    return data;
  };

  useEffect(() => {
    // fetch from api
    fetchInvitedUsers();
  }, []);

  return (
    <div
      className="table-container"
      style={{
        paddingInline: "150px",
      }}
    >
      <Table columns={columns} dataSource={invitedUserData} pagination={false} />
    </div>
  );
};

export default InvitedUsers;
